var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('computed-status-badge',{attrs:{"status-list":_vm.statusList,"value":_vm.notification.status}})}
var staticRenderFns = []

export { render, staticRenderFns }